__turbopack_context__.v({
  "card": "HmmRRq_card",
  "cardLocation": "HmmRRq_cardLocation",
  "cardTitle": "HmmRRq_cardTitle",
  "container": "HmmRRq_container",
  "dataColumn": "HmmRRq_dataColumn",
  "imageWrap": "HmmRRq_imageWrap",
  "inner": "HmmRRq_inner",
  "item": "HmmRRq_item",
  "kicker": "HmmRRq_kicker",
  "nav": "HmmRRq_nav",
  "navBtn": "HmmRRq_navBtn",
  "navBtnLeft": "HmmRRq_navBtnLeft",
  "navBtnRight": "HmmRRq_navBtnRight",
  "overlay": "HmmRRq_overlay",
  "poster": "HmmRRq_poster",
  "progress": "HmmRRq_progress",
  "rail": "HmmRRq_rail",
  "reveal-in": "HmmRRq_reveal-in",
  "section": "HmmRRq_section",
  "thumb": "HmmRRq_thumb",
  "title": "HmmRRq_title",
  "track": "HmmRRq_track",
  "viewport": "HmmRRq_viewport",
});
